module.exports = __webpack_public_path__ + "img/ic-warning-select-payment.498ec937.svg";